import _Vue, { PluginObject } from 'vue';

function loadScript(url: string) {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[src="' + url + '"]')) {
      resolve();

      return;
    }

    const el = document.createElement('script');

    el.type = 'text/javascript';
    el.async = true;
    el.src = url;

    el.addEventListener('load', resolve);
    el.addEventListener('error', reject);
    el.addEventListener('abort', reject);

    document.head.appendChild(el);
  });
}

class VueGoogleApi implements PluginObject<string> {
  // tslint:disable variable-name
  install(Vue: typeof _Vue): void {
    const key = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
    const urlParams = `key=${key}&libraries=places`;
    const url = `https://maps.googleapis.com/maps/api/js?${urlParams}`;

    loadScript(url).then(() => {
      Object.defineProperty(Vue.prototype, '$geocoder', {
        get() {
          return new window.google.maps.Geocoder();
        }
      });

      Object.defineProperty(Vue.prototype, '$googleMaps', {
        get() {
          return window.google.maps;
        }
      });
    });
  }
}

const vueGoogleApi = new VueGoogleApi();
export default vueGoogleApi;
